
import {
  AppointmentTypes,
  IRequestCardInfo,
  IRequestInfoParams,
  IRequestViewItem,
  RequestKindTypes,
  RequestStatuses,
} from "@/models/request";
import $API from "@/services";
import { computed, defineComponent, onMounted, onUpdated, reactive, Ref, ref } from "vue";
import { useI18n } from "vue-i18n";
import RequestInfo from "./RequestInfo";
import DoctorItem from "@/components/common/Doctors/DoctorItem.vue";
import RequestProgress from "@/components/common/Request/RequestProgress.vue";
import RequestProgressDesc from "@/components/common/Request/RequestProgressDescription.vue";
import DateFormat from "@/utils/date-format";
import FileList from "@/components/file/FileList.vue";
import { IFileListItem } from "@/models/file";
import { IDoctorListItem } from "@/models/doctor";
import { getDoctor } from "@/services/doctor";

export default defineComponent({
  name: "Request View",
  emits: ["CancelRequest", "deletedFile"],
  props: {
    id: {
      type: String,
      required: true,
    },
    isQuick: {
      type: Boolean,
      default: false,
    },
    orderNumber: {
      type: String,
      default: "",
    },
  },
  setup(props, { emit }) {
    const state = reactive({
      id: props.id,
      requestView: null as IRequestViewItem | null,
      files: null as Array<IFileListItem> | null,
      isLoading: true,
      doctor: undefined as IDoctorListItem | undefined,
      isQuick: props.isQuick,
    });

    const { t } = useI18n({ useScope: "global" });

    const onCancel = () => {
      emit("CancelRequest", state.id);
    };

    const cardInfo: Ref<IRequestCardInfo | null> = ref(null);
    const requestKind = computed(() =>
      state.requestView?.RequestKind === RequestKindTypes.OnlineCare
        ? t("face-to-face cooperation")
        : t("second opinion")
    );

    const appointmentType = computed(() =>
      state.requestView?.AppointmentType === AppointmentTypes.Appointment
        ? t("appointmentTypes.appointment")
        : t("appointmentTypes.telemedicine")
    );

    const hospitalNameAndDeptName = computed(()=>{
      return `${state.requestView?.DesiredHospitalName} ${state.requestView?.DesiredDeptName}`;
    });

    const hasHospitalNameAndDept = computed(()=>{
      return (
        !!state.requestView?.DesiredHospitalName && state.requestView?.DesiredHospitalName.length > 0 &&
        !!state.requestView?.DesiredDeptName && state.requestView?.DesiredDeptName.length > 0
      );
    });

    const scheduledDate = computed(() => {
      const date = state.requestView?.ScheduledDateTime;

      if (!date) return "";

      return `${DateFormat.splitDatetimeStringToString(date.valueOf())}`;
    });

    const insertDateTime = computed(() => {
      const date = state.requestView?.InsertDateTime;
      if (!date) return "";
      return `${DateFormat.splitDatetime(date.valueOf()).date}  ${t("requested")}`;
    });

    const deletedFile = () => {
      console.log("deletedFile called: RequestStatus=>", state.requestView?.RequestStatus);
      console.log("deletedFile called: state.id=>", state.id);

      if (state.requestView?.RequestStatus === RequestStatuses.Requested) emit("deletedFile");

      // 파일 다시 로드
      getFiles(state.id);
    };

    const getFiles = async (id: string) => {
      const ResultData = await $API.FileService.getFileList(id);
      if (!Array.isArray(ResultData)) return;
      state.files = ResultData;
    };

    onMounted(async () => {
      console.log("RequestView:onMounted");

      state.requestView = await $API.RequestService.getReqeustView(Number.parseInt(state.id));

      if (state.requestView) {
        state.doctor = await getDoctor(state.requestView.DoctorKey.toString());
      }

      await getFiles(state.id);

      cardInfo.value = RequestInfo(state.requestView as IRequestInfoParams, t, onCancel);

      state.isLoading = false;
    });

    onUpdated(() => {
      if (props.orderNumber && cardInfo.value && props.orderNumber !== cardInfo.value.message)
        cardInfo.value.message = props.orderNumber;
      console.log(cardInfo.value?.message);
    });

    return {
      state,
      cardInfo,
      requestKind,
      appointmentType,
      hospitalNameAndDeptName,
      hasHospitalNameAndDept,
      insertDateTime,
      RequestStatuses,
      scheduledDate,
      deletedFile,
      RequestKindTypes,
      t,
    };
  },
  components: {
    DoctorItem,
    RequestProgress,
    RequestProgressDesc,
    FileList,
  },
});
